// assets/visitor-id.js
(function(){
  const CNAME = 'inkd_vid';
  function uuid(){ return (crypto.randomUUID && crypto.randomUUID()) || 'v-' + Math.random().toString(36).slice(2) + Date.now(); }
  function getCookie(n){ return document.cookie.split('; ').find(r => r.startsWith(n+'='))?.split('=')[1]; }
  function setCookie(n,v,days){
    const d = new Date(); d.setTime(d.getTime() + (days*24*60*60*1000));
    document.cookie = `${n}=${v}; expires=${d.toUTCString()}; path=/; SameSite=Lax`;
  }
  let vid = getCookie(CNAME);
  if(!vid){ vid = uuid(); setCookie(CNAME, vid, 365); }
  window.INKD_VISITOR_ID = vid;
})();
